/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React, {FunctionComponent, MouseEventHandler} from 'react';
import {translate} from '@ion/core/src/locale/locale';
import {IconButton, IconButtonProps} from '@ion/dls/src/components/buttons/IconButton';
import {
  SaveIconTooltip
} from '../../icons/SaveIcon';
import {
  SaveIconDefault
} from '../../icons/SaveIconDefault';
import {
  SaveIconInChange
} from '../../icons/SaveIconInChange';
import {
  SaveIconInProgress
} from '../../icons/SaveIconInProgress';
import {IconProps} from '../../types/types';

export enum SaveIconTypes {
  DEFAULT = 'default',
  IN_PROGRESS = 'inprogress',
  CHANGED = 'changed'
}
export interface SaveIconButtonProps {
  onClick: MouseEventHandler<HTMLButtonElement>;
  type?: SaveIconTypes;
  buttonProps?: Omit<IconButtonProps, 'icon'>;
  iconProps?: IconProps;
};

// Provides the mapping between state prop and the respective save icon.
const saveIconMap = () => ({
  [SaveIconTypes.DEFAULT]     : SaveIconDefault,
  [SaveIconTypes.IN_PROGRESS] : SaveIconInProgress,
  [SaveIconTypes.CHANGED]     : SaveIconInChange
});

/**
 * Re-usable & Flexible Save Icon Button
 *
 * ```typescript
 *
 *  import {SaveIconButton} from '@ion/dls/src/components/buttons/';
 *
 *  <SaveIconButton type={'inprogress'}
 *    onClick={onClick} />
 *
 * ```
 */
export const SaveIconButton = ({
  onClick,
  buttonProps,
  iconProps,
  type = SaveIconTypes.DEFAULT
}: SaveIconButtonProps) => {
  const Icon: FunctionComponent<IconProps> = saveIconMap()[type];
  return (
    <SaveIconTooltip title={translate('common:editors.shared.save')}>
      <IconButton shouldWrap
        onClick={onClick}
        icon={<Icon {...iconProps} />}
        {...buttonProps} />
    </SaveIconTooltip>
  );
};
